import apiClient from "./axios";

// 业务伙伴相关API
export const businessPartnerApi = {
    // 获取业务伙伴列表
    getBusinessPartnerList: async (params = {}, config = {}) => {
        return await apiClient.get("/v3/contract/business-partners", { ...config, params });
    },

    // 获取单个业务伙伴
    getBusinessPartnerById: async (partnerId) => {
        return await apiClient.get(`/v3/contract/business-partners/${partnerId}`);
    },

    // 创建业务伙伴
    createBusinessPartner: async (data) => {
        return await apiClient.post("/v3/contract/business-partners", data);
    },

    // 更新业务伙伴
    updateBusinessPartner: async ({ id, data }) => {
        return await apiClient.put(`/v3/contract/business-partners/${id}`, data);
    },

    // 业务伙伴禁止物理删除，deleteBusinessPartner 已移除，服务端两个删除接口也已下掉。
    // 不再需要的记录用下面的 deactivateBusinessPartner 停用。

    // 激活业务伙伴
    activateBusinessPartner: async (partnerId, config = {}) => {
        return await apiClient.patch(`/v3/contract/business-partners/${partnerId}/activate`, undefined, config);
    },

    // 停用业务伙伴
    deactivateBusinessPartner: async (partnerId, config = {}) => {
        return await apiClient.patch(`/v3/contract/business-partners/${partnerId}/deactivate`, undefined, config);
    },

    // 获取供应商列表
    getSuppliers: async (params = {}) => {
        return await apiClient.get("/v3/contract/business-partners/suppliers", { params });
    },

    // 获取客户列表
    getCustomers: async (params = {}) => {
        return await apiClient.get("/v3/contract/business-partners/customers", { params });
    },
};

// 【合同管理模块】供应商关联产品管理API（用于合同项添加的UX增强）
export const productSelectorApi = {
    // 按供应商搜索产品
    searchProducts: async (params) => {
        return await apiClient.get("/v1/supplier-products/search-by-supplier", { params });
    },

    // 创建或获取产品
    createOrGetProduct: async (data) => {
        return await apiClient.post("/v1/supplier-products/create-or-get", data);
    },

    // 按供应商搜索产品套装
    searchBundles: async (params) => {
        return await apiClient.get("/v1/supplier-products/bundles/search-by-supplier", { params });
    },

    // 创建或获取产品套装
    createOrGetBundle: async (data) => {
        return await apiClient.post("/v1/supplier-products/bundles/create-or-get", data);
    },
};

// 【基础数据模块】产品管理API
export const productApi = {
    // 获取产品列表
    getProductList: async (params = {}) => {
        return await apiClient.get("/v1/master-data/products", { params });
    },

    // 获取单个产品
    getProductById: async (productId) => {
        return await apiClient.get(`/v1/master-data/products/${productId}`);
    },

    // 创建产品
    createProduct: async (data) => {
        return await apiClient.post("/v1/master-data/products", data);
    },

    // 更新产品
    updateProduct: async ({ id, data }) => {
        return await apiClient.put(`/v1/master-data/products/${id}`, data);
    },

    // 删除产品
    deleteProduct: async (productId) => {
        return await apiClient.delete(`/v1/master-data/products/${productId}`);
    },

    // 激活产品
    activateProduct: async (productId) => {
        return await apiClient.patch(`/v1/master-data/products/${productId}/activate`);
    },

    // 停用产品
    deactivateProduct: async (productId) => {
        return await apiClient.patch(`/v1/master-data/products/${productId}/deactivate`);
    },

    // 按服务类型搜索产品
    searchProductsByServiceType: async (params = {}) => {
        return await apiClient.get("/v1/master-data/products/search/by-service-type", { params });
    },
};

// 合同项相关API
export const contractItemApi = {
    // 获取合同项列表
    getContractItemList: async (params = {}) => {
        return await apiClient.get("/v1/contract-items", { params });
    },

    // 获取单个合同项
    getContractItemById: async (itemId) => {
        return await apiClient.get(`/v1/contract-items/${itemId}`);
    },

    // 创建合同项
    createContractItem: async (data) => {
        return await apiClient.post("/v1/contract-items", data);
    },

    // 更新合同项
    updateContractItem: async ({ id, data }) => {
        return await apiClient.put(`/v1/contract-items/${id}`, data);
    },

    // 删除合同项
    deleteContractItem: async (itemId) => {
        return await apiClient.delete(`/v1/contract-items/${itemId}`);
    },

    // 搜索合同项
    searchContractItems: async (params = {}) => {
        return await apiClient.get("/v1/contract-items/search", { params });
    },
};

// 产品套装相关API
export const productBundleApi = {
    // 获取产品套装列表
    getProductBundleList: async (params = {}) => {
        return await apiClient.get("/v1/product-bundles", { params });
    },

    // 获取单个产品套装
    getProductBundleById: async (bundleId) => {
        return await apiClient.get(`/v1/product-bundles/${bundleId}`);
    },

    // 创建产品套装
    createProductBundle: async (data) => {
        return await apiClient.post("/v1/product-bundles", data);
    },

    // 更新产品套装
    updateProductBundle: async ({ id, data }) => {
        return await apiClient.put(`/v1/product-bundles/${id}`, data);
    },

    // 删除产品套装
    deleteProductBundle: async (bundleId) => {
        return await apiClient.delete(`/v1/product-bundles/${bundleId}`);
    },

    // 展开产品套装（获取产品套装包含的所有产品）
    expandProductBundle: async (bundleId) => {
        return await apiClient.get(`/v1/product-bundles/${bundleId}/expand`);
    },

    // 搜索产品套装
    searchProductBundles: async (params = {}) => {
        return await apiClient.get("/v1/product-bundles/search", { params });
    },

    // === 产品套装项管理相关API ===

    // 获取产品套装项列表
    getBundleItemList: async (params = {}) => {
        const { bundle_id, ...otherParams } = params;
        return await apiClient.get(`/v1/product-bundles/${bundle_id}/items`, { params: otherParams });
    },

    // 添加产品套装项
    createBundleItem: async (data) => {
        const { bundle_id, product_id, quantity } = data;
        return await apiClient.post(`/v1/product-bundles/${bundle_id}/items`, null, {
            params: { product_id, quantity },
        });
    },

    // 更新产品套装项
    updateBundleItem: async (bundleItemId, data) => {
        const { bundle_id, quantity } = data;
        return await apiClient.put(`/v1/product-bundles/${bundle_id}/items/${bundleItemId}`, null, {
            params: { quantity },
        });
    },

    // 删除产品套装项
    deleteBundleItem: async (bundleItemId, bundleId) => {
        return await apiClient.delete(`/v1/product-bundles/${bundleId}/items/${bundleItemId}`);
    },
};

// 服务订单相关API
export const serviceOrderApi = {
    // 获取服务订单列表
    getServiceOrderList: async (params = {}) => {
        return await apiClient.get("/v1/service-orders", { params });
    },

    // 获取单个服务订单
    getServiceOrderById: async (orderId) => {
        return await apiClient.get(`/v1/service-orders/${orderId}`);
    },

    // 创建服务订单
    createServiceOrder: async (data) => {
        return await apiClient.post("/v1/service-orders", data);
    },

    // 更新服务订单
    updateServiceOrder: async ({ id, data }) => {
        return await apiClient.put(`/v1/service-orders/${id}`, data);
    },

    // 删除服务订单
    deleteServiceOrder: async (orderId) => {
        return await apiClient.delete(`/v1/service-orders/${orderId}`);
    },
};

// 燃油价格管理 API
export const fuelPriceApi = {
    // ─── 价格周期 CRUD ─────────────────────────────────

    // 获取价格周期列表（分页 + 筛选）
    getPricePeriods: async (params = {}) => {
        return await apiClient.get("/v1/fuel-prices/periods", { params });
    },

    // 获取单个价格周期
    getPricePeriodById: async (periodId) => {
        return await apiClient.get(`/v1/fuel-prices/periods/${periodId}`);
    },

    // 创建价格周期
    createPricePeriod: async (data) => {
        return await apiClient.post("/v1/fuel-prices/periods", data);
    },

    // 更新价格周期
    updatePricePeriod: async ({ id, data }) => {
        return await apiClient.put(`/v1/fuel-prices/periods/${id}`, data);
    },

    // 删除价格周期（仅 DRAFT 状态）
    deletePricePeriod: async (periodId) => {
        return await apiClient.delete(`/v1/fuel-prices/periods/${periodId}`);
    },

    // ─── 价格操作 ──────────────────────────────────────

    // 更新我方预算单价
    updateOurPrice: async (periodId, price) => {
        return await apiClient.patch(`/v1/fuel-prices/periods/${periodId}/our-price`, { price });
    },

    // 录入供应商确认价
    updateSupplierQuote: async (periodId, data) => {
        return await apiClient.patch(`/v1/fuel-prices/periods/${periodId}/supplier-quote`, data);
    },

    // 确认油价
    confirmPrice: async (periodId, data = {}) => {
        return await apiClient.patch(`/v1/fuel-prices/periods/${periodId}/confirm`, data);
    },

    // 标记异常
    disputePrice: async (periodId, data = {}) => {
        return await apiClient.patch(`/v1/fuel-prices/periods/${periodId}/dispute`, data);
    },

    // ─── 操作日志 ──────────────────────────────────────

    // 查询操作日志
    getOperationLogs: async (params = {}) => {
        return await apiClient.get("/v1/fuel-prices/operation-logs", { params });
    },
};

// 市场参考价管理 API
export const marketReferencePriceApi = {
    getSources: async (params = {}) => {
        return await apiClient.get("/v1/market-price-sources", { params });
    },

    getSourceById: async (sourceId) => {
        return await apiClient.get(`/v1/market-price-sources/${sourceId}`);
    },

    getSeries: async (params = {}) => {
        return await apiClient.get("/v1/market-price-series", { params });
    },

    getSeriesById: async (seriesId) => {
        return await apiClient.get(`/v1/market-price-series/${seriesId}`);
    },

    getDailyQuotes: async (params = {}) => {
        return await apiClient.get("/v1/market-price-daily-quotes", { params });
    },
};

// 导出所有API
export const contractManagementApi = {
    businessPartner: businessPartnerApi,
    product: productApi,
    productSelector: productSelectorApi,
    contractItem: contractItemApi,
    productBundle: productBundleApi,
    serviceOrder: serviceOrderApi,
    fuelPrice: fuelPriceApi,
    marketReferencePrice: marketReferencePriceApi,
};

export default contractManagementApi;
